import React from 'react';
import MentorshipSystem from '../components/Mentorship/MentorshipSystem';

const Mentorship: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="pb-6">
        <MentorshipSystem />
      </main>
    </div>
  );
};

export default Mentorship;
